import videojs from 'video.js';

const MenuItem = videojs.getComponent('MenuItem');

/**
 * A MenuItem to represent a privacy entry.
 *
 * @class PrivacyEntry
 * @extends videojs.MenuItem
 */
class PrivacyEntry extends MenuItem {
  constructor(player, options) {
    super(player, options);
  }

  handleClick(event) {
    super.handleClick(event);
    window.open(this.options_.link);
  }
}

const registerPrivacyIcon = ({ accountConfig, defaultConfig }) => {
  try {
    const config = { ...defaultConfig?.privacyIcon, ...accountConfig?.privacyIcon };

    if (!config.enable) return;

    const MenuButton = videojs.getComponent('MenuButton');
    const items = config.entries;

    class PrivacyIcon extends MenuButton {
      constructor(player, options) {
        super(player, options);
        super.controlText('Open privacy info menu');

        console.debug('PrivacyIcon: constructor', {
          items: PrivacyIcon.items,
        });
      }

      buildWrapperCSSClass() {
        return 'vjs-privacy-info-selector ' + super.buildWrapperCSSClass();
      }

      createItems() {
        const player = this.player();
        return items.map((item) => new PrivacyEntry(player, item));
      }
    }

    videojs.registerComponent('PrivacyIcon', PrivacyIcon);
  } catch ({ message }) {
    console.error(message);
  }
};

export default registerPrivacyIcon;
